import React, { forwardRef } from "react";
import { SearchInputProps } from "../../types/search";
import "../../styles.css";

/**
 * SearchInput - Controlled search input component
 *
 * This component is a controlled input that displays search state.
 * It receives value and onChange props from parent and can trigger clear action.
 *
 * Features:
 * - Fully controlled component
 * - Search icon
 * - Clear button that appears when there's text
 * - Forward ref to underlying input element
 */
const SearchInput = forwardRef<HTMLInputElement, SearchInputProps>(
  (
    {
      value = "",
      placeholder = "What do you want to find?",
      onChange,
      disabled = false,
      onClear, // Optional clear callback
      onKeyDown,
      autoComplete = "off",
      onBack,
    },
    ref
  ) => {
    const hasValue = value.trim().length > 0;

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
      const newValue = event.target.value;
      if (onChange) {
        onChange(newValue);
      }
    };

    const handleClear = () => {
      if (onChange) {
        onChange("");
      }
      if (onClear) {
        onClear();
      }
    };

    return (
      <div className="search-input-container">
        {/* Просто кнопка закрытия */}
        {onBack && (
          <button
            type="button"
            className="mobile-back-button"
            aria-label="Close search"
            onClick={onBack}
            disabled={disabled}
          >
            <img src="/src/img/back.svg" alt="" />
          </button>
        )}
        <input
          ref={ref}
          type="text"
          className="search-modal-input "
          placeholder={placeholder}
          value={value}
          onChange={handleChange}
          onKeyDown={onKeyDown}
          disabled={disabled}
          aria-label="Search input"
          autoComplete={autoComplete}
        />
        {/* Clear button - visible when there's text */}
        <button
          type="button"
          className="search-clear-button"
          aria-label="Clear search"
          style={{ visibility: hasValue ? "visible" : "hidden" }}
          onClick={handleClear}
          disabled={disabled}
        >
          <img src="/src/img/x.svg" />
        </button>
        <button type="button" className="search-button" aria-label="Search">
          <img src="/src/img/search-lg.svg" />
        </button>
      </div>
    );
  }
);

SearchInput.displayName = "SearchInput";

export default SearchInput;
